var map = {
	"./BAM": 4448,
	"./BAM.js": 4448,
	"./BED": 4149,
	"./BED.js": 4149,
	"./BIGBED": 617,
	"./BIGBED.js": 617,
	"./BIGWIG": 9658,
	"./BIGWIG.js": 9658,
	"./GFF": 8428,
	"./GFF.js": 8428,
	"./VCF": 1055,
	"./VCF.js": 1055,
	"./WIG": 8915,
	"./WIG.js": 8915
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5405;
module.exports = webpackAsyncContext;